export default {
  inject: ['inkline'],
  data: () => ({
    colorMode: null
  }),
  created () {
    if (this.inkline.options.colorMode === 'system') {
      if (document.body.classList.contains('-dark')) {
        this.colorMode = 'dark'
      } else {
        this.colorMode = 'light'
      }
    }
  }
}
